import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ForgetPasswordPopup from './ForgetPasswordPopup';
import { updatePassword } from '../../api/auth';

const commonWords = ["123456", "password", "123456789", "12345", "12345678", "qwerty", "1234567", "111111", "123123", "admin", "password1", "1234", "abcd1234", "letmein", "welcome", "monkey", "football", "1234567890", "admin123", "qwerty123"];
const previousPasswords: string[] = []; // This should be fetched securely from backend
let invalidAttempts = 0;

const PasswordReset = () => {
  const navigate = useNavigate();
  const { key, emailParam } = useParams();

  const [password, setPassword] = useState<any>({
    setPassword: "",
    setConfirmPassword: ""
  });
  const [showPassword, setShowPassword] = useState<any>({
    showPassword: false,
    showConfirmPassword: false
  });
  const [isError, setIsError] = useState<boolean>(false);
  const [err, setError] = useState<string>('');
  const [isForgetPassword, setForgetPassword] = useState<boolean>(false);
  const [conditions, setConditions] = useState({
    hasMinLength: false,
    hasUpperCase: false,
    hasNumber: false,
    hasSpecialChar: false,
    isNotCommonWord: true,
  });

  const validatePasswordConditions = (password: string) => {
    return {
      hasMinLength: password.length >= 12,
      hasUpperCase: /[A-Z]/.test(password),
      hasNumber: /\d/.test(password),
      hasSpecialChar: /[!@#$%^&*(),.?":{}|<>[\]`~\-_=+;|]/.test(password),
      isNotCommonWord: !commonWords.some(word => password.toLowerCase().includes(word)),
    };
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowPassword({
      ...showPassword,
      showConfirmPassword: !showPassword.showConfirmPassword
    });
  };

  useEffect(() => {
    setIsError(password.setPassword !== password.setConfirmPassword && password.setConfirmPassword.length > 0);
  }, [password]);

  const togglePasswordVisibility = () => {
    setShowPassword({
      ...showPassword,
      showPassword: !showPassword.showPassword
    });
  };

  const updatePasswordConditions = (password: string) => {
    const updatedConditions = validatePasswordConditions(password);
    setConditions(updatedConditions);
    return Object.values(updatedConditions).every(Boolean);
  };

  const handleSubmit = async () => {
    if (invalidAttempts >= 5) {
      setError("Too many failed attempts. Please try again later.");
      return;
    }

    if (emailParam && password.setPassword && key) {
      if (!updatePasswordConditions(password.setPassword)) {
        setError("Password does not meet security requirements.");
        invalidAttempts++;
        return;
      }

      try {
        await updatePassword({ email: emailParam, key: key, password: password.setPassword });
        setError("");
        setForgetPassword(true);
      } catch (e: any) {
        setError(e.response?.data?.message || "Error updating password");
        invalidAttempts++;
      }
    }
  };

  const handleOnBlur = () => {
    setIsError(password.setPassword !== password.setConfirmPassword);
  };

  return (
    <div className='login d-flex'>
      <div className="actionBar">
        <button className='backBtn btnNoStyle'>
          <img src={"./../../assets/images/arrow-left.png"} onClick={() => navigate("/verify-email")} alt="leftArrow" />
        </button>
      </div>
      <div className="imgContent passwordReset">
        <div className="imgBox">
          <img src={"./../../assets/images/unlock.png"} alt="unlock" />
        </div>
        <div className='loginForm'>
          <div className="formRow">
            <div className="radioOverlay">
              <input className='formControl text-center' type={showPassword.showPassword ? 'text' : 'password'} placeholder='Password' name="password" onChange={(e) => {
                setPassword({
                  ...password,
                  setPassword: e.target.value
                });
                updatePasswordConditions(e.target.value);
              }} ></input>
              <label className="customRadio">
                <span onClick={togglePasswordVisibility}>
                  {showPassword.showPassword ? <img className='checkmark' src='.\..\..\assets\ygbadmin\images\login\eye-off.svg' alt='eye off' /> : <img className='checkmark' src='.\..\..\assets\ygbadmin\images\login\eye-on.svg' alt='eye on' />}
                </span>
              </label>
            </div>

          </div>
          <div className="formRow">
            <div className="radioOverlay">
              <input className={isError ? 'formControl text-center error' : "formControl text-center"} type={showPassword.showConfirmPassword ? 'text' : 'password'} placeholder='Confirm Password' name="password" onChange={(e) => {
                setPassword({
                  ...password,
                  setConfirmPassword: e.target.value
                })
              }} onBlur={handleOnBlur} ></input>
              <label className="customRadio">
                <span onClick={toggleConfirmPasswordVisibility}>
                  {showPassword.showConfirmPassword ? <img className='checkmark' src='.\..\..\assets\ygbadmin\images\login\eye-off.svg' alt='eye off' /> : <img className='checkmark' src='.\..\..\assets\ygbadmin\images\login\eye-on.svg' alt='eye on' />}
                </span>
              </label>
            </div>

          </div>
          <br />
          <ul className="passwordTips">
            <li style={{ color: conditions.hasMinLength ? "green" : "red" }}>At least 12 characters long</li>
            <li style={{ color: conditions.hasUpperCase ? "green" : "red" }}>At least 1 uppercase letter</li>
            <li style={{ color: conditions.hasNumber ? "green" : "red" }}>At least 1 number</li>
            <li style={{ color: conditions.hasSpecialChar ? "green" : "red" }}>At least 1 special character (!, @, #, etc.)</li>
            <li style={{ color: conditions.isNotCommonWord ? "green" : "red" }}>Must not contain common words</li>
          </ul>
        </div>
      </div>
      <p className='errorText'>{err}</p>
      <div className='bottomBlock d-flex justify-content-center'>
        <button className='blueBtn' onClick={handleSubmit} type="submit" disabled={isError || !Object.values(conditions).every(Boolean)}>Send</button>
      </div>
      {isForgetPassword && <ForgetPasswordPopup onclick={() => navigate("/")} handleClick={() => navigate("/")} heading='Your new password has been saved!' buttonTxt1='Continue' />}
    </div>
  );
};

export default PasswordReset;
